var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 14 14",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.996 11.095h.61v2.034c0 .464.426.871.914.871.488 0 .915-.407.915-.871v-2.034h1.22v2.034c0 .464.427.871.915.871.488 0 .915-.407.915-.871v-2.034h.61c.366 0 .61-.232.61-.58l-.001-5.98H3.386v5.98c0 .348.244.58.61.58zM2.079 4.381c-.418 0-.784.439-.784.94v4.392c0 .502.366.941.784.941.418 0 .784-.439.784-.94V5.321c0-.502-.366-.941-.784-.941zm9.148.94v4.392c0 .502.366.941.785.941.418 0 .784-.439.784-.94V5.321c0-.502-.366-.941-.784-.941-.419 0-.785.439-.785.94zM9.973.51a.272.272 0 000-.407.305.305 0 00-.427 0L8.63.974C8.204.683 7.655.567 7.045.567a3.78 3.78 0 00-1.647.349L4.545.044a.704.704 0 00-.488 0 .614.614 0 000 .465l.793.755c-.854.64-1.464 1.628-1.464 2.768h7.319A3.31 3.31 0 009.18 1.264L9.973.51zM6.068 3.06H5.029V2.016h1.039V3.06zm1.985 0V2.016h1.038V3.06H8.053z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.4566ee7e71d99c46bfaf580eb0866281.svg";
export { ForwardRef as ReactComponent };